import { IconButton } from '@mui/material';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import * as theme from '../../../theme';

export default function ListItem({ children, ...props }) {
  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className={'cardLink'} style={{ display: 'flex', flex: 3, width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => props.onClick(props.id)}>
        <div style={{ ...theme.Container.flexRowFixed, padding: 8 }}>
          <PermContactCalendarIcon sx={{ flex: '0 0 auto' }} />
          <div style={{ flex: 1, fontSize: 14, fontWeight: 500 }}>
            {props.label}
            <br />
            <span style={{ fontWeight: 'normal', fontSize: '0.85em', color: theme.Colors.GrayMedium }}>{props.content}</span>
          </div>
          
        </div>
      </div>
      <div style={{ display: 'flex', flex: 0.5, justifyContent: 'right', width: '100%'}} onClick={() => props.onClick(props.id)}>
        <IconButton aria-label="navigate" color="secondary">
          <NavigateNextIcon sx={{ fontSize: 24 }} />
        </IconButton>
      </div>
    </div>
  );
}